import { Component, Inject } from '@angular/core';
import { Note, NoteDefaultValues } from '../note';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-note-form',
    templateUrl: './note-form.component.html',
    styleUrls: ['./note-form.component.scss'],
    standalone: false
})
export class NoteFormComponent {
  selectedNote: Note = NoteDefaultValues();
  participantClassByRole: string = '';
  translations: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NoteFormComponent>,
    private themeService: ParticipantThemeService,
    private translationService: TranslationService
  ) { }


  ngOnInit(): void {
    if (this.data) {
      this.selectedNote.id = this.data.id;
      this.selectedNote.note = this.data.note;
    }

    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
